import { useEffect, useState } from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import KomboSupplementSyncStatus from 'modules/payroll_integrations_kombo/components/SupplementSyncStatus'
import CompanyInstallationsChecker from 'modules/payroll_integrations_kombo/lib/CompanyInstallations/checker'
import {
  IntegrationLabels,
  IntegrationTools,
} from 'modules/payroll_integrations_kombo/lib/constants'

interface Props {
  supplementId: number
  policyPeriodId: number
  policyPeriodStatus: string
  hover: boolean
}

const SupplementSyncStatus = ({
  supplementId,
  policyPeriodId,
  policyPeriodStatus,
  hover,
}: Props) => {
  const [integrationTool, setIntegrationTool] = useState<IntegrationTools>()
  const [integrationLabel, setIntegrationLabel] = useState<string>()

  const [datevApiInstalled, setDatevApiInstalled] = useState<boolean>(false)
  const [datevLugInstalled, setDatevLugInstalled] = useState<boolean>(false)

  useAsyncData(async () => {
    setDatevApiInstalled(await CompanyInstallationsChecker.isDatevApiInstalled())
    setDatevLugInstalled(await CompanyInstallationsChecker.isDatevLugInstalled())
  }, [])

  useEffect(() => {
    if (!datevApiInstalled && !datevLugInstalled) return

    if (datevApiInstalled) {
      setIntegrationTool(IntegrationTools.datev)
      setIntegrationLabel(IntegrationLabels.datev)
    } else if (datevLugInstalled) {
      setIntegrationTool(IntegrationTools.datevLug)
      setIntegrationLabel(IntegrationLabels.datevLug)
    }
  }, [datevApiInstalled, datevLugInstalled])

  return (
    <>
      {integrationTool !== undefined && integrationLabel !== undefined && (
        <KomboSupplementSyncStatus
          key={integrationTool + supplementId}
          supplementId={supplementId}
          policyPeriodId={policyPeriodId}
          policyPeriodStatus={policyPeriodStatus}
          integrationTool={integrationTool}
          integrationLabel={integrationLabel}
          hover={hover}
        />
      )}
    </>
  )
}

export default SupplementSyncStatus
